<template>
  <div class="pagenation">
    <table class="pagenation_contents">
      <!-- ページャー -->
      <tr class="pager">
        <td class="previous"></td>
        <td class="center_field">
          <a
            href="#"
            @click="showPrev"
            v-if="showPrevButton"
            :class="isStartPage ? 'disabled' : ''"
          >
            ≪
          </a>
          <a
            href="#"
            @click="showPrev"
            v-if="showPrevButton"
            :class="isStartPage ? 'disabled' : ''"
          >
            ＜
          </a>
          <label class="items_number"> 1 2 3 </label>
          <label>…</label>
          <label class="items_number"> 10 </label>
          <a
            href="#"
            @click="showNext"
            v-if="showNextButton"
            :class="isEndPage ? 'disabled' : ''"
          >
            ＞
          </a>
          <a
            href="#"
            @click="showNext"
            v-if="showNextButton"
            :class="isEndPage ? 'disabled' : ''"
          >
            ≫
          </a>
        </td>
        <td class="next"></td>
      </tr>
      <!-- 件数 -->
      <tr class="pager_count">
        <td class="previous"></td>
        <td class="center_field">
          <label class="items_number">
            {{ ItemNumber }}
          </label>
          <label> / </label>
          <label class="items_number"> {{ itemsLength }}件 </label>
        </td>
        <td class="next"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ['dispItems'],
  data() {
    return {
      page: 0,
      dispItemSize: 20,
      backButton: require('../img/back.png'),
      nextButton: require('../img/next.png')
    }
  },
  computed: {
    itemsLength() {
      return this.dispItems.length
    },
    startPage() {
      return this.page * this.dispItemSize
    },
    startItem() {
      return this.startPage + 1
    },
    lastItem() {
      if (this.isEndPage) {
        return this.dispItems.length
      }
      return this.startPage + this.dispItemSize
    },
    ItemNumber() {
      if (this.lastItem === 0) {
        return 0
      }
      if (this.startItem >= this.lastItem) {
        return this.lastItem
      }
      return this.startItem + '-' + this.lastItem
    },
    dispItemsSplice() {
      return this.dispItems.slice(
        this.startPage,
        this.startPage + this.dispItemSize
      )
    },
    isStartPage() {
      return this.page === 0
    },
    isEndPage() {
      return (this.page + 1) * this.dispItemSize >= this.dispItems.length
    },
    showPrevButton() {
      if (this.isStartPage === true) {
        return false
      }
      return true
    },
    showNextButton() {
      if (this.isEndPage === true) {
        return false
      }
      return true
    }
  },
  created() {
    // ページが表示された時にリストを生成し親に渡す。
    this.$emit('child-event', this.dispItemsSplice)
  },
  updated() {
    // データが更新された時にリストを生成し親に渡す。
    if (this.dispItemsSplice.length === 0) {
      this.page = 0
    }
    this.$emit('child-event', this.dispItemsSplice)
  },
  methods: {
    showPrev() {
      if (this.isStartPage) {
        return
      }
      this.page--
      this.$emit('child-event', this.dispItemsSplice)
    },
    showNext() {
      if (this.isEndPage) {
        return
      }
      this.page++
      this.$emit('child-event', this.dispItemsSplice)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pagenation.vue